export default __webpack_public_path__ + "static/media/B.e70be642.mp3";